import { formatApiError } from '@/services/api';

/** Error code of the backend's requireVerifiedEmail middleware (403). */
export const EMAIL_NOT_VERIFIED_CODE = 'EMAIL_NOT_VERIFIED';

export const isEmailNotVerifiedCode = (code: string | undefined | null): boolean =>
  code === EMAIL_NOT_VERIFIED_CODE;

export const isEmailNotVerifiedError = (error: unknown): boolean =>
  isEmailNotVerifiedCode(formatApiError(error).code);
